var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('hvh-freeze-data-table',{class:{ disabled: false },attrs:{"headers":_vm.headers_,"items":_vm.modelData,"loading":false}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }